
import { Component } from "react";
import Loader from "../../../../../utils/Loader";
import { ToastContainer } from "react-toastify";
import ConfirmationModal from "../../../../../common_components/confirmationa_modal";
import ExhibitorHeader from "../../../../../common_components/exhibitor_module_header";
import ExhibitorDrawer from "../../../../../common_components/exhibitor_module_drawer";
import ExhibitorTopMenu from "../../../../../common_components/exhibitor_module_topmenu";
import { withRouter } from "../../../../../utils/withRouter";
import { connect } from "react-redux";
import {
  toastError,
  toastSuccess,
  powerGuidlineAmountActionId,
  formatAmount,
} from "../../../../../utils/constants";
import {
  getPowerConnectionList_action,
  submitPowerConnection_action,
  getPowerConnectionDetails_action,
} from "../../../../../actions/exhibitor_module_actions/manual_Forms_actions/forms_actions/power_connection_action/power_connection_action";
import Modal from "react-modal";
import { data, event } from "jquery";
import HeaderWithLogo from "../../../../../common_components/header_with_logo";
import AdminDrawer from "../../../../../common_components/admin_module_drawer";
import moment from "moment";
import { fill_action } from "../../../../../actions/fillCombo_action";
import VendorDrawer from "../../../../../common_components/vendor_module_drawer";
import VendorDetails from "../../vendorDetails";
//
class PowerConnection extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      PowerConnectionList: [],
      confirmationObj: { message: '', buttonName: '', action: '' },
      popArg: [],
      isOpenConfirmationModal: false,
      Is_Agree: false,
      Remark: "",
      CGST: "",
      SGST: "",
      IGST: "",
      Is_AgreeErr: "",
      DeadlineDate: "",
      DeadlineDateString: "",
      currentDate: moment().format("DD-MM-YYYY"),
      Is_View: false,
      StatusID: "",
      isCollapse: false,
      CurrencyName: "",
      powerGuidlineAmountData: [],
      RoleID: sessionStorage.getItem("RoleIDSS"),
      isHideSection: sessionStorage.getItem("RoleIDSS") != 1 && sessionStorage.getItem("RoleIDSS") != 8,
      IsIGST: false,
      ValidationErr: ''
    };
    this.getPowerConnectionList = this.getPowerConnectionList.bind(this);
    this.calculateTotals = this.calculateTotals.bind(this);

    this.handleConfirmation = this.handleConfirmation.bind(this)
  }


  handleConfirmation(flag) {
    const { confirmationObj, popArg } = this.state;
    if (flag) {
      if (confirmationObj.action == 0) {
        this.submitPowerConnection()
      }
    }
    this.setState({ isOpenConfirmationModal: false })
  }

  async componentDidMount() {
    this.getFillList(powerGuidlineAmountActionId, "", "", "", "", "");
    this.setState({
      DeadlineDate:
        this.props.location.state != null &&
          this.props.location.state != "" &&
          this.props.location.state.Deadline != ""
          ? moment(this.props.location.state.Deadline).format("DD-MM-YYYY")
          : "",
      DeadlineDateString:
        this.props.location.state != null &&
          this.props.location.state != "" &&
          this.props.location.state.Deadline != ""
          ? this.props.location.state.Deadline
          : "",
      Is_View:
        this.props.location.state != null &&
          this.props.location.state != "" &&
          this.props.location.state.is_View != null
          ? this.props.location.state.is_View
          : sessionStorage.getItem("RoleIDSS") != 1,
      StatusID:
        this.props.location.state != null &&
          this.props.location.state != "" &&
          this.props.location.state.StatusID != null
          ? this.props.location.state.StatusID
          : "",
    });

    await this.getPowerConnectionList();
  }

  getFillList(actionID, exhibitionID, moduleID, keyValue, value, from) {
    const { } = this.state;
    this.setState({ isLoading: true });
    this.props
      .fill_action(actionID, exhibitionID, moduleID, keyValue, value)
      .then((data) => {
        if (data.error != 1) {
          // country list
          if (actionID === powerGuidlineAmountActionId) {
            this.setState({
              powerGuidlineAmountData: data.data,
            });
          }
        }
      })
      .catch((e) => {
        console.log(e);
      });
  }

  async getPowerConnectionDetails() {
    this.setState({ isLoading: true });
    this.props
      .getPowerConnectionDetails_action()
      .then((data) => {
        if (data.error != 1) {
          if (data.data != "") {
            this.setState({
              PowerConnectionList: data.data,
              CGST: data.data[0]["CGST"] * 100,
              SGST: data.data[0]["SGST"] * 100,
              Remark: data.data[0]["Remark"],
              Is_Agree: data.data[0]["Is_Agree"],
            });
          }
          this.setState({ isLoading: false });
        } else {
          this.setState({ isLoading: false });
          toastError(data.msg);
        }
      })
      .catch((e) => {
        console.log(e);
      });
  }

  async getPowerConnectionList() {
    this.setState({ isLoading: true });
    this.props
      .getPowerConnectionList_action()
      .then((data) => {
        if (data.error != 1) {
          console.log("hello", data.data);
          data.data.map((item) => {
            if (item.Quantity == "" || item.Quantity == null) {
              item["Amount"] = 0;
            }
          });
          this.setState(
            {
              PowerConnectionList: data.data,
              IsIGST: data.IGST[0]['IsIGST'],
              CGST: data.data[0]["CGST"] * 100,
              SGST: data.data[0]["SGST"] * 100,
              IGST: data.data[0]["IGST"] * 100,
              CurrencyName: data.data[0]["CurrencyName"],
            },
            () => this.getPowerConnectionDetails()
          );
          this.setState({ isLoading: false });
        } else {
          this.setState({ isLoading: false });
          toastError(data.msg);
        }
      })
      .catch((e) => {
        console.log(e);
      });
  }

  submitPowerConnection() {
    const { PowerConnectionList, Remark, Is_Agree, ValidationErr } = this.state;
    const { totalAmount } = this.calculateTotals;

    const newArray = [];
    PowerConnectionList.map((data, i) => {
      newArray.push({
        ServiceID: data.ServiceID,
        Rates: data.Rates,
        Quantity: data.Quantity != "" ? parseInt(data.Quantity) : 0,
        Amount: data.Amount,
      });
    });
    this.inputValidate();
    const flag = PowerConnectionList.every(
      (item) => item.Quantity == "" || item.Quantity == 0
    );
    const ManualFormsID = this.props.location.state?.ManualFormsID || null;
    const ServiceID = this.props.location.state?.ServiceID || null;
    const VendorDetails = this.props.location.state?.VendorDetails || {};
    if (Is_Agree) {
      if (!flag) {
        if (ValidationErr == '') {
          this.setState({ isLoading: true });
          this.props
            .submitPowerConnection_action(
              Remark,
              Is_Agree == true ? 1 : 0,
              newArray,
              ManualFormsID,
              ServiceID,
              VendorDetails
            )
            .then((data) => {
              if (data.error != 1) {
                this.setState({ isLoading: false });
                toastSuccess(
                  this.state.StatusID == 0
                    ? "Power Connection Form Submitted Successfully"
                    : "Power Connection Form Updated Successfully"
                );
                setTimeout(() => {
                  this.props.navigate("/manualForms");
                }, 2000);
              } else {
                this.setState({ isLoading: false });
                toastError(data.msg);
              }
            })
            .catch((e) => {
              console.log(e);
            });
        } else {
          toastError("Please enter valid quantity");
        }
      } else {
        this.setState({ isLoading: false });
        toastError("Please enter quantity");
      }
    } else {
      this.setState({ isLoading: false });
      toastError("kindly agree the terms and conditions");
    }
  }

  calculateTotals() {
    try {
      const { PowerConnectionList } = this.state;
      let totalAmount = 0;
      PowerConnectionList.forEach((data) => {
        totalAmount += Number(data.Amount);
      });
      return {
        totalAmount,
      };
    } catch (e) {
      console.log("exception : ", e);
    }
  }

  handleCancel() {
    window.history.back();
  }

  enterQuantity(e, index) {
    const { PowerConnectionList } = this.state;
    const list = [...PowerConnectionList];
    const event = e.target.value.replace(/\D/, "");
    for (let i = 0; i < list.length; i++) {
      if (i == index) {
        list[i]["Quantity"] = event;
        if (event != "" && event != 0) {
          list[i]["Amount"] = event * list[i]["Rates"];
        } else {
          list[i]["Amount"] = 0;
        }

        if (i == 0) {
          if (event > 3) {
            this.setState({ ValidationErr: 'Maximum 3 quantities allowed for single phase. Apply for three phase for more' })
          } else {
            this.setState({ ValidationErr: '' })
          }
        }
      }
    }
    this.setState({
      PowerConnectionList: list,
    });
  }

  inputValidate() {
    const { Is_Agree } = this.state;

    if (Is_Agree == 0 || Is_Agree == false) {
      this.setState({ Is_AgreeErr: "kindly agree the terms and condition" });
    }
  }

  render() {
    const {
      isLoading,
      Is_Agree,
      Remark,
      PowerConnectionList,
      SGST,
      CGST,
      Is_AgreeErr,
      currentDate,
      DeadlineDate,
      Is_View,
      StatusID,
      isCollapse,
      CurrencyName,
      powerGuidlineAmountData,
      DeadlineDateString,
      IGST,
      RoleID,
      isHideSection,
      IsIGST,
      ValidationErr, isOpenConfirmationModal
    } = this.state;
    console.log("IGST---->", IGST)
    const { totalAmount } = this.calculateTotals();
    const isDeadlinePassed =
      DeadlineDate &&
      moment(DeadlineDate, "DD-MM-YYYY").isValid() &&
      moment(currentDate, "DD-MM-YYYY").isAfter(
        moment(DeadlineDate, "DD-MM-YYYY")
      );
    console.log("first", this.props);
    return (
      <>
        {isOpenConfirmationModal ? <ConfirmationModal onConfirmation={this.handleConfirmation} message={this.state.confirmationObj} /> : null}
        {isLoading ? <Loader></Loader> : null}
        <ToastContainer />
        {!isHideSection && (
          <>
            {JSON.parse(sessionStorage.getItem("loginDataSS")).RoleID == 1 ||
              JSON.parse(sessionStorage.getItem("loginDataSS")).RoleID == 8 ? (
              <ExhibitorHeader />
            ) : (
              <HeaderWithLogo />
            )}
            {JSON.parse(sessionStorage.getItem("loginDataSS")).RoleID == 1 ||
              JSON.parse(sessionStorage.getItem("loginDataSS")).RoleID == 8 ? (
              <ExhibitorDrawer />
            ) : JSON.parse(sessionStorage.getItem("loginDataSS")).RoleID ==
              7 ? (
              <VendorDrawer />
            ) : (
              <AdminDrawer />
            )}
          </>
        )}
        <div
          className={!isHideSection ? "with-dr-container" : ""}
          style={{ marginTop: RoleID == 1 ? "0px" : "" }}
        >
          <div className="main-container">
            {!isHideSection && (
              <div className="row">
                {JSON.parse(sessionStorage.getItem("loginDataSS")).RoleID ==
                  1 ||
                  JSON.parse(sessionStorage.getItem("loginDataSS")).RoleID ==
                  8 ? (
                  <ExhibitorTopMenu />
                ) : null}
              </div>
            )}
            <div className="p-2">
              <div className="row m-0">
                <div class="card rounded-1 border mt-7 p-0">
                  <div class="card-header d-flex">
                    <h3 class="card-title">Power Connection Guideline's</h3>
                    {!isHideSection && (
                      <p
                        className="text-aqua mb-0 mx-2"
                        style={{
                          // textDecoration: "underline",
                          // color: "blue",
                          cursor: "pointer",
                        }}
                        onClick={() =>
                          this.setState({ isCollapse: !isCollapse })
                        }
                      >
                        Click here to {isCollapse ? "hide" : "read"} Guidelines
                      </p>
                    )}
                  </div>
                  <div class="card-body p-1 m-2">
                    {isCollapse && (
                      <div>
                        <ol type="1)" style={{ textAlign: "left" }}>
                          <li>
                            Exhibitors under Bare Space category are required to
                            apply for power supply and pay electricity
                            connection/consumption charges on the basis of
                            required connected load for machinery, including
                            lighting and air-conditioning. Exhibitors’ should
                            inform their power requirements along with the
                            payment towards power charges before{" "}
                            <strong className="text-aqua">
                              {new Date(DeadlineDateString).toLocaleDateString(
                                "en-GB",
                                {
                                  day: "numeric",
                                  month: "numeric",
                                  year: "numeric",
                                }
                              )}
                            </strong>
                            .
                          </li>
                          <li>
                            Exhibitors should note that 1kw supply/outlet is
                            compulsory in every single stall as a facility for
                            lighting. Every exhibitor must submit their layout
                            plan with indication of point of power supply.
                          </li>
                          <li>
                            The stall contractors undertaking lighting work
                            shall possess valid electrical wireman license..
                          </li>
                          <li>
                            The load ≤ 3 kW shall be fed through single phase
                            electrical supply at 230V AC ± 6 % and load {">"} 3
                            kW shall be fed through 3 Phase electrical Supply at
                            415V AC ± 6 % The supply Frequency will ne 50Hz ±
                            3%. d.
                          </li>
                          <li>
                            The exhibitor requiring supply at voltage level
                            other than above shall make necessary arrangement
                            for the level matching equipment such as
                            transformer, voltage stabilizer, inverter etc. to
                            match the supply voltage level to their load..
                          </li>
                          <li>
                            The frame of stationary motor and the metallic
                            parts, not intended as conductors, including
                            transformers and any other apparatus used for
                            regulating or controlling electricity of voltage
                            exceeding 250V but not exceeding 650V shall be
                            earthed firmly by the conductor size as mention.{" "}
                          </li>
                          <li>
                            Exhibitor are advised to make arrangement for power
                            conditioning equipment such as UPS, CVT etc. for
                            their critical & supply sensitive load/ equipment
                            operating under very narrow band of tolerance
                          </li>
                          <li>
                            The contractors shall use BIS marked PVC insulated
                            650/1100 V copper conductor wire for supplying
                            electrical power to lighting & motive load to be
                            installed in stall
                          </li>
                          <li>
                            All switch boards shall conform to BIS & to Indian
                            Electricity Act (amended).
                          </li>
                          <li>
                            The insulation tape used shall carry IS marking
                          </li>
                          <li>
                            For lighting circuit, the minimum wire size shall be
                            1.5/2.5 sq.mm PVC insulated 650V grade FRLS copper
                            wire. For 16A power point, the minimum wire size
                            shall be 4sq.mm PVC insulated 650V grade FRLS copper
                            wire. The IR value of cable used shall not be less
                            than 1MΩ when measured with 500V DC megger
                          </li>
                          <li>
                            Exhibitor can bring international adopter for their
                            internal electrical connection
                          </li>
                          <li>
                            The contractor shall use following size of
                            protective conductors for equipment at their stall
                            from point of supply (MCB Box).
                          </li>
                          <div class="table-responsive">
                            <table class="table border text-nowrap text-md-nowrap table-bordered mb-2 mt-2 w-50">
                              <thead>
                                <tr>
                                  <th>Size of phase conductor</th>
                                  <th>
                                    Size of protective conductor of the same
                                    material as phase conductor
                                  </th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr>
                                  <td>Up to 4mm²</td>
                                  <td>Same size as that of phase conductor</td>
                                </tr>
                                <tr>
                                  <td>Above 4mm² & up to 16mm²</td>
                                  <td>Same size as that of phase conductor</td>
                                </tr>
                                <tr>
                                  <td>Above 16mm² & up to 35mm²</td>
                                  <td>16mm²</td>
                                </tr>
                                <tr>
                                  <td>Above 35mm²</td>
                                  <td>Half size of phase conductor</td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                          <li>
                            The earth wires shall be connected to the main earth
                            firmly. After switching the entire load at stall,
                            the voltage between neutral & earth shall not exceed
                            10V.
                          </li>
                          <li>
                            Exhibitor shall ensure that, the contractor shall
                            carry out all electrical works in the stall area as
                            per Indian Electricity Rules 2005/ CEA Regulation
                            2010/ General Specifications for Electrical Works,
                            Part I & II by CPWD.
                          </li>
                          <li>
                            The Contractor shall carry out wiring at their
                            installation as per IS-732:2010 with all safety
                            precautions.
                          </li>
                          <li>
                            The load connected to power point shall be suitable
                            for the socket and under no circumstances exceed the
                            rated current capacity of the socket.
                          </li>
                          <li>
                            Exhibitors must install separate and independent
                            MCBs/MCCBs/RCCBs of appropriated rating for their
                            individual machines so as to automatically
                            disconnect the supply in case of a) Overload b)
                            Earth leakage or earth fault c) short circuit.
                          </li>
                          <li>
                            It is mandatory to use only reputed make wires like
                            Polycab, KEI, Anchor etc and MCB/RCCB like Legrand,
                            Siemens, ABB, Schneider for the electrical
                            installation.
                          </li>
                          <li>
                            Wherever 3 ph connection is requested, the load
                            shall be evenly distributed on all three phases. The
                            current through neutral conductor or in other words,
                            the current unbalance shall not exceed 5%.
                          </li>
                          <li>
                            The contractor shall also ensure that conductor size
                            of the cable/ wire is suitable to cater connected
                            load without overloading/overheating in normal
                            operation and during abnormal conditions. This may
                            be checked and verified by electrical consultant.
                          </li>
                          <li>
                            In case any material used by the contractor is found
                            to be of inferior or sub-standard quality, the
                            contractor shall be responsible for replacing the
                            same without any loss of time as per the quality
                            mutually agreed and mentioned above.
                          </li>
                          <li>
                            It is recommended to make use of low loss/ low
                            heating choke manufactured as per IS and of reputed
                            make namely Philips, Crompton, Bajaj, Wipro or
                            equivalent.
                          </li>
                          <li>
                            The contractor shall control maximum 10 points or
                            800 watts whichever less, from single point.
                          </li>
                          <li>
                            Joint to the wires in any place is unacceptable.
                            However, good quality connector of adequate rating
                            properly covered cab be used.
                          </li>
                          <li>
                            Use 3-pin top / industrial to shall be made to take
                            supply from sockets. The third pin shall be
                            connected to earth through protective (loop
                            earthing) conductor. It is strictly prohibited to
                            insert wires directly into socket for drawing
                            supply.
                          </li>
                          <li>
                            Adequate access to main power supply (relieving
                            point) at stall shall be provided for cleaning &
                            maintenance purpose. A clear space of not less than
                            1 meter shall be provided in front of the
                            switchboard. Materials particularly combustible
                            shall not be dumped at this location.
                          </li>
                          <li>
                            All main electrical supply points must be kept
                            easily accessible for operation and repairs and for
                            isolation of power in the event of emergency. These
                            should not be concealed or covered under any
                            circumstances.
                          </li>
                          <li>
                            Exhibitors requesting for 3-phase supply shall draw
                            single phase power for lighting purpose from 3-phase
                            supply outlet using double pole MCBs. The double
                            pole MCB/RCCB shall be arranged by the exhibitor.
                          </li>
                          <li>
                            The electrical supply will be released only after
                            completion of wiring work conforming to the Indian
                            standards & codes of wiring and to the satisfaction
                            of Electrical consultant.
                          </li>
                          <li>
                            UPS/Stabiliser with rating greater than 3kVA should
                            have 3 Phase Input.
                          </li>
                          <li>
                            1 point of power supply will be provided to below 15
                            kw.
                          </li>
                          <li>
                            Exhibitors may contact the Electrical Consultant at
                            venue office for any technical queries.
                          </li>
                          <li>
                            Exhibitors under Shell Scheme package would be
                            provided with a plug point socket and a switch for a
                            230 V, 6 Amp A.C. supply. Consumption of power
                            through this plug point for the connected load upto
                            1 kw is included in the cost of shell scheme
                            package. However, additional power would be made
                            available to them on extra payment.
                          </li>
                          <li>
                            Exhibitors shall bring their own electrical cables,
                            wires, sockets, international electrical adaptor to
                            connect their electrical installation.
                          </li>
                          <li>
                            The Exhibition authority arrange for supply of power
                            will be entrusted with the authority for regulating
                            and controlling the power supply to the exhibition
                            halls and individual stalls.
                          </li>
                          <li>ELECTRICAL INSTALLATION REGULATIONS</li>
                          <ol>
                            <li>
                              Electrical wiring and installation must be done by
                              Exhibitors through registered professional
                              technicians using proper wiring, switches etc. so
                              as to ensure safety. The Organisers shall not be
                              responsible or liable in case of any mishap due to
                              use of sub-standard material or unskilled labour.
                            </li>
                            <li>
                              Lamps and appliances with high temperature
                              surfaces should be guarded and used well away from
                              combustible materials.
                            </li>
                            <li>
                              No light fitting or other appliance may be
                              suspended from the roof of the exhibition hall.
                            </li>
                            <li>
                              Exhibitors are requested to review their internal
                              wiring and connections thoroughly before going
                              live. Also, Members should estimate the power
                              requirement in advance so that, appropriate load
                              management can be done. Switching from temporary
                              to permanent power supply should be done in
                              advance clear two days, so that testing and
                              balancing can be done properly.
                            </li>
                            <li>
                              Exhibitor shall submit Electrical Work Completion
                              Report to Hall Directors for permanent power
                              connection as per the format. Power will be
                              released on receipt of the completion report.
                            </li>
                            <li>
                              The Organisers reserve the right to disconnect any
                              installation, which in their opinion is dangerous
                              or likely to cause annoyance to visitors or other
                              Exhibitors
                            </li>
                            <li>
                              In order to take care of voltage fluctuations, the
                              Exhibitors are advised to fix up constant voltage
                              transformers or insulation Transformer or
                              stabilizers for CNC and other sensitive machines.
                              Exhibitors are encouraged to use MCCB wherever
                              necessary. The main supply points and electrical
                              installations in the stand should be kept open for
                              easy access and should not be concealed.
                            </li>
                            <li>
                              Electrical power should be drawn from designated
                              points allocated to the exhibitor only. Any
                              exhibitor or its designated contractor found
                              drawing power from unauthorized sources will be
                              liable to forfeiter of security deposit{" "}
                            </li>
                          </ol>
                        </ol>
                        <div style={{ textAlign: "left" }}>
                          <strong>Note :</strong> In case of any dispute arising
                          in case of “Safety” and “consumption of power drawn”.
                          The judgment by consultant will be final & binding on
                          the contractor/Exhibitor.
                        </div>
                        <p>
                          If details of requirements along with the payment from
                          Exhibitors, received by INDIA ITME Society after{" "}
                          <strong>
                            deadline (
                            {new Date(DeadlineDateString).toLocaleDateString(
                              "en-GB",
                              {
                                day: "numeric",
                                month: "numeric",
                                year: "numeric",
                              }
                            )}
                            ), then additional surcharge of 25% of basic rates
                            shall be applicable to the Exhibitors
                          </strong>
                          .
                        </p>
                      </div>
                    )}
                    {!isHideSection && (
                      <>
                        <p className="fw-semibold">The tariff for electric power will be as under:</p>
                        <p className="fw-semibold">Connection/Consumption charges for power supply to</p>
                        <ol style={{ textAlign: "left" }}>
                          {CurrencyName == "INR" ? (
                            <li>
                              For Indian exhibitors Rs
                              {powerGuidlineAmountData != "" &&
                                `₹ ${powerGuidlineAmountData[0]["Amount_in_INR"]}/-`}{" "}
                              per KW of connected load including lighting and
                              air conditioning load. Plus GST @ 18% (as per
                              Government rule) or as applicable is payable with
                              all the payments will not be refunded.
                            </li>
                          ) : (
                            <li>
                              For Foreign exhibitors US Dollar{" "}
                              {powerGuidlineAmountData != "" &&
                                `$ ${powerGuidlineAmountData[0]["Amount_in_USD"]}/-`}
                              /- per KW of connected load including lighting and
                              air conditioning load. Plus GST @ 18% (as per
                              Government rule) or as applicable is payable with
                              all the payments will not be refunded.
                            </li>
                          )}
                          <li>
                            If the total power requirement is more than 3 KW,
                            then the exhibitor will get 3 phase supply
                            connection only.
                          </li>
                          <li>
                            The power supply will be authorized by the
                            Exhibition Authority after prescribed charges are
                            received latest by{" "}
                            {this.props.location?.state?.ActualDeadline
                              ? moment(
                                this.props.location.state.ActualDeadline
                              ).format("DD-MM-YYYY")
                              : "-"}
                            .
                          </li>
                        </ol>
                        {/* <p>
                          For more details or any queries please contact:
                          itme@india-itme.com, gttes@india-itme.com{" "}
                        </p> */}
                        <VendorDetails />
                        {!isHideSection && (
                          <div className="row mt-4">
                            <h6 className="mt-2 ">
                              Power Connection{" "}
                              <span className="text-danger">
                                {" "}
                                Last Date Of Submission -{" "}
                                {this.props.location?.state?.ActualDeadline
                                  ? moment(
                                    this.props.location.state.ActualDeadline
                                  ).format("DD-MM-YYYY")
                                  : "-"}
                              </span>
                            </h6>
                          </div>
                        )}
                      </>
                    )}
                    <div class="table-responsive">
                      <table class="table border text-nowrap text-md-nowrap table-bordered mb-0 mt-1">
                        <thead>
                          <tr>
                            <th>Description of Service</th>
                            {!isHideSection && <th>Rates ({CurrencyName})</th>}
                            <th style={{ width: '400px' }}>Quantity</th>
                            {!isHideSection && <th>Amount({CurrencyName})</th>}
                          </tr>
                        </thead>
                        <tbody>
                          {PowerConnectionList.length > 0 &&
                            PowerConnectionList != null ? (
                            PowerConnectionList.map((data, i) => (
                              <>
                                <tr>
                                  <td>{data.Description}</td>
                                  {!isHideSection && (
                                    <td style={{ textAlign: "right" }}>
                                      {formatAmount(data.Rates)}
                                    </td>
                                  )}
                                  <td>
                                    <input
                                      type="text"
                                      class="form-control"
                                      value={data.Quantity}
                                      disabled={
                                        Is_View ||
                                        isDeadlinePassed ||
                                        StatusID == 2
                                      }
                                      maxLength={i == 0 ? 1 : 4}
                                      onChange={(e) => this.enterQuantity(e, i)}
                                    />
                                    {i == 0 &&
                                      <span className="text-danger text-start text-left d-block mt-1">
                                        {ValidationErr}
                                      </span>
                                    }
                                  </td>
                                  {!isHideSection && (
                                    <td style={{ textAlign: "right" }}>
                                      {formatAmount(data.Amount)}
                                    </td>
                                  )}
                                </tr>
                              </>
                            ))
                          ) : (
                            <></>
                          )}
                          {!isHideSection && (
                            <>
                              <tr>
                                <td colspan="2"></td>
                                <td>Total
                                </td>
                                <td className="fw-semibold" style={{ textAlign: "right" }}>
                                  {formatAmount(totalAmount)}
                                </td>
                              </tr>
                              {!IsIGST ? (
                                <>
                                  <tr>
                                    <td colspan="2"></td>
                                    <td className="fw-semibold">
                                      CGST @ {CGST}%
                                    </td>
                                    <td className="fw-semibold" style={{ textAlign: "right" }}>
                                      {formatAmount(
                                        (CGST / 100) * totalAmount
                                      )}
                                    </td>
                                  </tr>
                                  <tr>
                                    <td colspan="2"></td>
                                    <td className="fw-semibold">
                                      SGST @ {SGST}%
                                    </td>
                                    <td className="fw-semibold" style={{ textAlign: "right" }}>
                                      {formatAmount(
                                        (SGST / 100) * totalAmount
                                      )}
                                    </td>
                                  </tr>
                                </>
                              ) : (
                                <tr>
                                  <td colspan="2"></td>
                                  <td className="fw-semibold">
                                    IGST @ {IGST}%
                                  </td>
                                  <td className="fw-semibold" style={{ textAlign: "right" }}>

                                    {formatAmount((IGST / 100) * totalAmount)}

                                  </td>
                                </tr>
                              )}
                              <tr style={{ backgroundcolor: "#eee" }}>
                                <td colspan="2"></td>
                                <td className="fw-semibold">Grand Total
                                </td>
                                <td className="fw-semibold" style={{ textAlign: "right" }}>
                                  {formatAmount(
                                    (CGST / 100) * totalAmount +
                                    (SGST / 100) * totalAmount +
                                    totalAmount
                                  )}
                                </td>
                              </tr>
                            </>
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
                <div className="row m-0 p-0">
                  <label className="px-0">Remark</label>
                  <textarea
                    class="form-control"
                    value={Remark}
                    maxLength={1000}
                    onChange={(e) => this.setState({ Remark: e.target.value })}
                    disabled={Is_View || isDeadlinePassed || StatusID == 2}
                    rows="3"
                  ></textarea>
                  <label
                    class="d-flex mt-1 p-0 mt-3"
                    style={{ lineheight: "15px;" }}
                  >
                    <input
                      type="checkbox"
                      checked={Is_Agree}
                      disabled={Is_View || isDeadlinePassed || StatusID == 2}
                      onChange={(e) =>
                        this.setState({
                          Is_Agree: e.target.checked,
                          Is_AgreeErr: "",
                        })
                      }
                    />
                    We hereby read &amp; understood the above mentioned clauses
                    &amp; consequences. We accept &amp; agree to abide by the
                    same.
                  </label>
                  {
                    <span className="text-danger text-start text-left d-block mt-1">
                      {Is_AgreeErr}
                    </span>
                  }
                </div>
              </div>
              <div className="row m-0">
                {isDeadlinePassed && (
                  <span className="text-danger">
                    THE DEADLINE TO FILL OUT THE FORM HAS PASSED.
                  </span>
                )}
              </div>
              {!isHideSection && (
                <div className="d-flex justify-content-end mt-0">
                  {!Is_View ? (
                    <button
                      type="button"
                      className="btn btn-aqua rounded-1 d-block mt-3 mb-3"
                      style={{ marginRight: 10 }}
                      disabled={isDeadlinePassed || StatusID == 2}
                      // onClick={() => this.submitPowerConnection()}
                      onClick={() => this.setState({ isOpenConfirmationModal: true, confirmationObj: { message: `Do you want to  ${this.state.StatusID == 0 ? "Submit" : "Update"}?`, buttonName: this.state.StatusID == 0 ? "Submit" : "Update", action: 0 }, popArg: [] })}
                    >
                      {this.state.StatusID == 0 ? "Submit" : "Update"}
                    </button>
                  ) : (
                    <></>
                  )}
                  <button
                    type="button"
                    className="btn rounded-1 mt-3 mb-3 btn-gray"
                    onClick={() => this.handleCancel()}
                  >
                    Back
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default withRouter(
  connect(null, {
    getPowerConnectionList_action,
    submitPowerConnection_action,
    getPowerConnectionDetails_action,
    fill_action,
  })(PowerConnection)
);
